import * as React from 'react';
import { UIHeading4, Body1 } from '@cian/ui-kit';

import * as styles from './AboutRealtorDesktop.css';

interface IDescriptionRowProps {
  label: string;
  text: string;
  action?(): void;
}

export const DescriptionRow = ({ label, text, action }: IDescriptionRowProps) => {
  return (
    <div className={styles['row']}>
      <div className={styles['about-title']}>
        <UIHeading4>{label}</UIHeading4>
      </div>
      <span className={styles['about-text']}>
        <Body1 whiteSpace="pre-line">{text}</Body1>
        {action && (
          <span className={styles['maximize-button']}>
            <Body1 color="text-main-default" onClick={action}>
              Развернуть
            </Body1>
          </span>
        )}
      </span>
    </div>
  );
};
